import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { CustomFieldId, FormCustomFieldFragment } from 'common/src/generated/types';
import * as React from 'react';
import { AttachFormCustomFieldsAddButton } from './attachFormCustomFieldsAddButton';

interface IAttachFormCustomFieldsEmptyProps {
    formCustomFields: FormCustomFieldFragment[];
    selectedCustomFieldsIds: Set<CustomFieldId>;

    toggle(field: FormCustomFieldFragment): void;
}

export const AttachFormCustomFieldsEmpty = (props: IAttachFormCustomFieldsEmptyProps) => {
    const { translate } = useHeavent();

    return (
        <Flex
            align="center"
            css={{
                background: '$gray50',
                bd: 'gray200 2',
                padding: '$6'
            }}
            direction="column"
            gap="2"
            width={1}
        >
            <Box font="gray800 textSm medium">{translate('aucun_champ_per_72101')}</Box>

            <AttachFormCustomFieldsAddButton
                formCustomFields={props.formCustomFields}
                selectedCustomFieldsIds={props.selectedCustomFieldsIds}
                toggle={props.toggle}
            />
        </Flex>
    );
};
